import { DataGrid as DataGrid1 } from '@tableau/data-grid-1-wrapper';
import { TabStyles } from '@tableau/widgets';
import { DataGrid } from '@tableau/widgets-datagrid';
import _ from 'underscore';

import { Messages } from '../../codegen/Localize';
import { CommonDataGridColumns } from '../../common/react/CommonDataGridColumns';
import { DataGridCells } from '../../common/react/components/dataGrid/DataGridCells';
import { SortableHeader } from '../../common/react/components/dataGrid/SortableHeader';
import { FeatureFlags } from '../../ts/FeatureFlags';
import { PlainTextCell } from '../spaces/ListView/dataGridCells/PlainTextAndNumberCells';
import { PlainTextHeader } from '../spaces/ListView/dataGridCells/PlainTextHeader';

export type FlowScheduledTasksGridRow = {
  readonly outputStepName: string;
  readonly outputName: string;
  readonly outputType: string;
  readonly outputLocation: string;
};

const styleOverride = {
  paddingLeft: 0,
};
const headerStyle = {
  fontSize: TabStyles.Typography.Sizing.Default,
  fontWeight: 500
};

export module FlowScheduledTasksGrid {
  export function columns(): DataGrid.Column[] {
    const outputStepColumn: DataGrid.Column = {
      name: 'output-step-col',
      dataKey: 'outputStepName',
      sortable: false,
      growToFit: true,
      headerText: Messages.flowRunHistoryColumn_output(),
      headerFormatter: PlainTextHeader(headerStyle),
      resizable: false,
      cellFormatter: PlainTextCell('outputStepName', 'outputStepNameCell', styleOverride)
    };
    const outputNameColumn: DataGrid.Column = {
      name: 'output-name-col',
      dataKey: 'outputName',
      sortable: false,
      headerText: Messages.flowOverviewOutputNameColumnName(),
      headerFormatter: PlainTextHeader(headerStyle),
      resizable: false,
      cellFormatter: PlainTextCell('outputName', 'outputNameCell', styleOverride)
    };
    const outputTypeColumn: DataGrid.Column = {
      name: 'output-type-col',
      dataKey: 'outputType',
      sortable: false,
      headerText: Messages.flowScheduledTaskType(),
      headerFormatter: PlainTextHeader(headerStyle),
      resizable: false,
      cellFormatter: PlainTextCell('outputType', 'outputTypeCell', styleOverride)
    };

    const outputLocationColumn: DataGrid.Column = {
      name: 'output-location-col',
      dataKey: 'outputLocation',
      sortable: false,
      headerText: Messages.flowScheduledTaskLocation(),
      headerFormatter: PlainTextHeader(headerStyle),
      resizable: false,
      cellFormatter: PlainTextCell('outputLocation', 'outputLocationCell', styleOverride)
    };
    const refreshTypeColumn: DataGrid.Column = {
      name: 'output-refresh-col',
      dataKey: 'outputRefreshType',
      sortable: false,
      headerText: Messages.column_task_type(),
      headerFormatter: PlainTextHeader(headerStyle),
      resizable: false,
      cellFormatter: PlainTextCell('outputRefreshType', 'outputRefreshTypeCell', styleOverride)
    };
    return [
      outputStepColumn,
      outputNameColumn,
      outputTypeColumn,
      outputLocationColumn,
      FeatureFlags.incrementalRefresh ? refreshTypeColumn : null
    ];
  }
  // These columns use the old Data-Grid v1
  export function columns_v1(): DataGrid1.Column[] {

    const outputStepColumn: DataGrid1.Column = CommonDataGridColumns.withExtraSpace(
      {
        name: 'output-step-col',
        dataKey: 'outputStepName',
        sortable: false,
        headerText: Messages.flowRunHistoryColumn_output(),
        direction: 'desc',
        headerFormatter: SortableHeader.Formatter(),
        cellFormatter: DataGridCells.PlainTextCell('outputStepName')
      },
    );

    const outputNameColumn: DataGrid1.Column = {
      name: 'output-name-col',
      dataKey: 'outputName',
      sortable: false,
      preferredWidth: 300,
      headerText: Messages.flowOverviewOutputNameColumnName(),
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCell('outputName')
    };

    const outputTypeColumn: DataGrid1.Column = {
      name: 'output-type-col',
      dataKey: 'outputType',
      sortable: false,
      headerText: Messages.flowScheduledTaskType(),
      direction: 'desc',
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCell('outputType')
    };

    const outputLocationColumn: DataGrid1.Column = {
      name: 'output-location-col',
      dataKey: 'outputLocation',
      sortable: false,
      headerText: Messages.flowScheduledTaskLocation(),
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCell('outputLocation')
    };

    const refreshTypeColumn: DataGrid1.Column = {
      name: 'output-refresh-col',
      dataKey: 'outputRefreshType',
      sortable: false,
      headerText: Messages.column_task_type(),
      headerFormatter: SortableHeader.Formatter(),
      cellFormatter: DataGridCells.PlainTextCell('outputRefreshType')
    };

    return _.compact([
      outputStepColumn,
      outputNameColumn,
      outputTypeColumn,
      outputLocationColumn,
      FeatureFlags.incrementalRefresh ? refreshTypeColumn : null
    ]);
  }
}
